import React from "react";
import { motion } from "framer-motion";
import ProjectsList from "./projectsList/ProjectsList";

const Projects = () => {
  return (
    <motion.div
      initial={
          {
              opacity: 0,
          }
      }
      animate={
          {
              opacity: 1,
          }
      }
      exit={
          {
              opacity: 0,
          }
      }
    >
      <ProjectsList />
    </motion.div>
  );
};

export default Projects;
